/*
 * @Author: Admni
 * @Description: 
 * @Date: 2020-11-17 16:32:17
 * @LastEditTime: 2021-02-08 10:29:11
 */
import Cookies from 'js-cookie'
import moment from 'moment'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  curApp: localStorage.getItem('curPkg'),
  curEvent: localStorage.getItem('curEvent'),
  pickerOptions: {
    shortcuts: [{
      text: '昨天',
      onClick(picker) {
        const end = moment().day(moment().day() - 1).format('YYYY-MM-DD')
        const start = moment().day(moment().day() - 1).format('YYYY-MM-DD')
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '今天',
      onClick(picker) {
        const end = moment().day(moment().day() ).format('YYYY-MM-DD')
        const start = moment().day(moment().day() ).format('YYYY-MM-DD')
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '这周',
      onClick(picker) {
        const end = moment().weekday(7).format('YYYY-MM-DD')
        const start = moment().weekday(1).format('YYYY-MM-DD')
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '上周',
      onClick(picker) {
        const end = moment().weekday(0).format('YYYY-MM-DD')
        const start = moment().weekday(-6).format('YYYY-MM-DD')
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '这个月',
      onClick(picker) {
        const start = moment().month(moment().month()).startOf('month').format('YYYY-MM-DD')
        const end = moment().month(moment().month()).endOf('month').format('YYYY-MM-DD')
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '上个月',
      onClick(picker) {
        const start = moment().month(moment().month() - 1).startOf('month').format('YYYY-MM-DD')
        const end = moment().month(moment().month() - 1).endOf('month').format('YYYY-MM-DD')
        picker.$emit('pick', [start, end]);
      }
    }]
  },
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  SET_APP: (state, value) => {
    state.curApp = value
  },
  SET_EVENT: (state, value) => {
    state.curEvent = value
  }
}

const actions = {
  toggleSideBar({
    commit
  }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({
    commit
  }, {
    withoutAnimation
  }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({
    commit
  }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({
    commit
  }, size) {
    commit('SET_SIZE', size)
  },
  setApp({
    commit
  }, value) {
    commit('SET_APP', value)
  },
  setEvent({commit}, value){
    commit('SET_EVENT', value)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}